import { freeze } from '@reduxjs/toolkit';
import {
  IMeasureDisplayFormatInput,
  MeasureDisplayFormatKind,
  MeasureDisplayFormatOperator,
} from '../../../apollo/graphqlSchema';
import { globalFormat } from '../../../formatting';
import getCurrencySymbol from '../../../formatting/getCurrencySymbol';
import { UnreachableCaseError } from 'ts-essentials';

export const getMeasureDisplayFormatKindLabel = (
  formatKind: MeasureDisplayFormatKind,
) => {
  switch (formatKind) {
    case MeasureDisplayFormatKind.Number:
      return '#';
    case MeasureDisplayFormatKind.Percent:
      return '%';
    case MeasureDisplayFormatKind.Currency:
      const { currency, locale } = globalFormat.getGlobalFormat();
      return getCurrencySymbol(currency, locale);
    default:
      throw new UnreachableCaseError(formatKind);
  }
};
export const measureDisplayFormatCalculationUnitLookup: Record<
  MeasureDisplayFormatOperator,
  string
> = {
  [MeasureDisplayFormatOperator.Divide]: '÷',
  [MeasureDisplayFormatOperator.Multiply]: '×',
};

export const defaultMeasureDisplayFormatInput =
  freeze<IMeasureDisplayFormatInput>({
    calculationUnit: null,
    calculationValue: null,
    decimalPlace: 0,
    kind: MeasureDisplayFormatKind.Number,
    unit: null,
  });
